import { JT } from "./jumbotronTokens";

// Presentational leg chip (§4a variant 1b). All progress math is done by the caller
// (SlipTicket); this component only renders what it receives.
export default function LegChip({ text, marketText, color, tappable, onTap, showBar, pct, ratio, barGradient }) {
  const isInteractive = tappable && onTap;
  const tapProps = isInteractive ? {
    role:"button", tabIndex:0,
    onClick:onTap,
    onKeyDown:(e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); onTap(e); } },
    style:{ cursor:"pointer" },
  } : {};
  const width = `${Math.max(Number(pct) || 0, 3)}%`;
  return (
    <div {...tapProps} style={{
      position:"relative", overflow:"hidden",
      background:JT.bg.well, borderRadius:JT.radius.chip,
      border:`1px solid ${isInteractive ? JT.border.chip : JT.border.inset}`,
      padding: showBar ? "7px 10px 9px" : "7px 10px",   // +3px height only when the bar is present
      marginBottom:5, ...(tapProps.style||{}),
    }}>
      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ fontSize:11, fontWeight:800, color, whiteSpace:"nowrap", minWidth:0, overflow:"hidden", textOverflow:"ellipsis" }}>{text}</span>
        {marketText && <span style={{ fontSize:11, fontWeight:700, color:JT.text.tertiary, flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{marketText}</span>}
        {ratio != null && <span style={{ fontSize:11, fontWeight:900, color, flexShrink:0, whiteSpace:"nowrap" }}>{ratio}</span>}
        {isInteractive && <span aria-hidden="true" style={{ fontSize:12, color:JT.brand.accent }}>›</span>}
      </div>
      {showBar && (
        <div style={{ position:"absolute", left:0, right:0, bottom:0, height:3, background:JT.border.default }}>
          <div data-testid="leg-bar-fill" style={{
            height:"100%", width, background:barGradient,
            transition:"width .8s cubic-bezier(.4,0,.2,1)",
          }}/>
        </div>
      )}
    </div>
  );
}
